import React, { ChangeEvent, useState, useEffect } from "react";
import { Form, Button, Table } from 'react-bootstrap';
import { Container } from './styles';
import Box from '@mui/material/Box';
import Slider from '@mui/material/Slider';
import { Tabela } from './styles';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import CircularProgress, { CircularProgressProps } from '@mui/material/CircularProgress';
import Typography from '@mui/material/Typography';
import FormLabel from '@mui/material/FormLabel';
import FormControlLabel from '@mui/material/FormControlLabel';
import NativeSelect from '@mui/material/NativeSelect';
import InputLabel from '@mui/material/InputLabel';
import api from '../../../services/api';
import FormControl from '@mui/material/FormControl';
import InputMask from 'react-input-mask';
import TextField from '@mui/material/TextField';
import { useToast } from '../../../hooks/toast';
import { Contato } from '../../../interfaces/contato';
import LocalizationProvider from '@mui/lab/LocalizationProvider';
import DesktopDatePicker from '@mui/lab/DesktopDatePicker';
import { ptBR } from 'date-fns/locale';
import AdapterDateFns from '@mui/lab/AdapterDateFns';
import Checkbox from '@mui/material/Checkbox';
import Card from '@mui/material/Card';
import CardHeader from '@mui/material/CardHeader';
import Avatar from '@mui/material/Avatar';
import { FiPlus, FiXCircle } from 'react-icons/fi';
import { BiPhone } from 'react-icons/bi';
import { AiOutlineMail } from 'react-icons/ai';
import IconButton from '@mui/material/IconButton';
import Tooltip, { TooltipProps, tooltipClasses } from '@mui/material/Tooltip';
import { styled } from '@mui/material/styles';
import { ContatoConsulta } from '../../../interfaces/contatoConsulta';
import { Parametros } from '../../../interfaces/parametros';
import copy from 'copy-to-clipboard';
import cep from 'cep-promise';
import { cores } from '../../../mock/cores';
import { Col, Row } from "../styles";


const LightTooltip = styled(({ className, ...props }: TooltipProps) => (
  <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: theme.palette.common.white,
    color: 'rgba(0, 0, 0, 0.87)',
    boxShadow: theme.shadows[1],
    fontSize: 14,
  },
}));

const FIXO = {
  telefone: 'Telefone Residencial',
  mascara: '(99) 9999-9999',
}

const WHATSAPP = {
  telefone: 'WhatsApp',
  mascara: '(99) 99999-9999'
}

const CELULAR = {
  telefone: 'Celular',
  mascara: '(99) 99999-9999',
}

const COMERCIAL = {
  telefone: 'Telefone Comercial',
  mascara: '(99) 9999-9999',
}



export function Etapa3Endereco(props: any) {

  const { addToast } = useToast();
  const { DadosVenda, setAlteraDados, setAlteraPagina } = props
  const [contatosBanco, setContatosBanco] = useState<Parametros[]>();
  const [contact, setContact] = useState<Omit<Contato, "id" | "dadoUsuario">[]>([])
  const [campoEmail, setCampoEmail] = React.useState({ tipoContato: "EMAIL", valor: '' })
  const [campoFone, setCamposFone] = React.useState(CELULAR)


  const [modelContato, setModelContato] = useState<Omit<Contato, "id" | "dadoUsuario">>({
    tipoContato: 'CELULAR',
    valor: '',
  })


  const pessoaJuridica = {
    documentoPrincipal: 'CNPJ',
    mascaraPessoa: '99.999.999/9999-99',
  }

  const [camposPessoa, setCamposPessoa] = React.useState(pessoaJuridica);
  const [age, setAge] = React.useState<Date | null>(null);
  const [model, setModel] = useState({
    data: ''
  })

  function adicionaZero(numero: number) {
    if (numero <= 9)
      return "0" + numero;
    else
      return numero;
  }

  const handleChangeDate = (newValue: Date | null) => {
    if (newValue != undefined) {
      setAge(newValue)
      let DataFormatada = ((adicionaZero(newValue.getFullYear())) + "-" + (adicionaZero(newValue.getMonth() + 1)) + "-" + (adicionaZero(newValue.getDate())))
      setModel({
        ...model,
        data: DataFormatada
      });
    }
  };

  async function inserirContatoTelefone() {
    if (modelContato.valor.length < 13) {
      addToast({
        type: 'info',
        title: 'Digite Telefone Válido',
        description: 'Digite um telefone Válido!'
      })
      return
    }

    let tel = ""

    if (DadosVenda.telefone1 === "") {
      tel = `telefone1`;
    } else if (DadosVenda.telefone2 === "") {
      tel = `telefone2`;
    } else if (DadosVenda.telefone3 === "") {
      tel = 'telefone3'
    } else {
      tel = 'telefone4'
    }


    if (DadosVenda.idTelefone >= 5) {
      addToast({
        type: 'info',
        title: 'Limite Máximo de Telefones',
        description: 'O limite máximo de telefones é 4!'
      })
      return
    }

    let valor = modelContato.valor
    if (modelContato.valor.length === 13) {
      const parte1 = modelContato.valor.slice(0, 9)
      const parte2 = modelContato.valor.slice(9, 13)
      console.log(parte1)
      console.log(parte2)
      valor = `${parte1}-${parte2}`
    } else {
      const parte1 = modelContato.valor.slice(0, 10)
      const parte2 = modelContato.valor.slice(10, 14)
      valor = `${parte1}-${parte2}`
    }
    console.log(modelContato.valor.length)

    setAlteraDados({ ...DadosVenda, [tel]: valor, idTelefone: DadosVenda.idTelefone + 1 })





    setModelContato({
      ...modelContato,
      valor: ''
    })
  }

  async function inserirContatoEmail() {
    let re = /\S+@\S+\.\S+/;
    let valido = re.test(campoEmail.valor);
    if (!valido) {
      addToast({
        type: 'info',
        title: 'Digite E-mail Válido',
        description: 'Digite um e-mail Válido!'
      })
      return
    }

    let email = "";

    if (DadosVenda.email1 === "") {
      email = `email1`;
    } else if (DadosVenda.email2 === "") {
      email = `email2`;
    } else if (DadosVenda.email3 === "") {
      email = 'email3'
    } else {
      email = 'email4'
    }

    if (DadosVenda.idEmail >= 5) {
      addToast({
        type: 'info',
        title: 'Limite Máximo de Emails',
        description: 'O limite máximo de emails é 4!'
      })
      return
    }

    setAlteraDados({ ...DadosVenda, [email]: campoEmail.valor, idEmail: DadosVenda.idEmail + 1 })

    setCampoEmail({ ...campoEmail, valor: '' })


  }

  function randomDarkRGB() {
    var r = Math.floor(Math.random() * 156);
    var g = Math.floor(Math.random() * 156);
    var b = Math.floor(Math.random() * 156);
    var bgColor = "rgb(" + r + "," + g + "," + b + ")";
    return bgColor;
  }

  async function excluirEmail(dado: string) {
    setAlteraDados({ ...DadosVenda, [dado]: "", idEmail: DadosVenda.idEmail - 1 })
  }

  async function excluirFone(dado: string) {
    setAlteraDados({ ...DadosVenda, [dado]: "", idTelefone: DadosVenda.idTelefone - 1 })
  }


  async function buscaCep(x: string) {
    if (x.length === 8) {
      try {
        let resultado = await cep(x)
        console.log(resultado)
        if (resultado.street) {
          setAlteraDados({
            ...DadosVenda,
            cep: x,
            endereco: resultado.street.toUpperCase(),
            bairro: resultado.neighborhood.toUpperCase(),
            cidade: resultado.city.toUpperCase(),
            uf: resultado.state.toUpperCase(),
          })
        } else {
          addToast({
            type: 'info',
            title: 'Cep não encontrato!',
            description: 'Não encontramos este cep na base de dados!'
          });
          setAlteraDados({
            ...DadosVenda,
            cep: x,
            endereco: "",
            bairro: "",
            cidade: "",
            uf: "",
          })
        }
      } catch (err) {
        addToast({
          type: 'info',
          title: 'Cep não encontrato!',
          description: 'Não encontramos este cep na base de dados!'
        });
        setAlteraDados({
          ...DadosVenda,
          cep: x,
          endereco: "",
          bairro: "",
          cidade: "",
          uf: "",
        })
      }
    }
  }

  function handleChangeSelectContato(e: ChangeEvent<HTMLSelectElement>) {

    setModelContato({
      ...modelContato,
      [e.target.name]: e.target.value
    })

    if (e.target.value === 'RESIDENCIAL') {
      setCamposFone(FIXO)
    } else if (e.target.value === 'WHATSAPP') {
      setCamposFone(WHATSAPP)
    } else if (e.target.value === 'CELULAR') {
      setCamposFone(CELULAR)
    } else {
      setCamposFone(COMERCIAL)
    }
  }

  const handleChangeInput = (e: React.ChangeEvent<HTMLInputElement>) => {
    let resultado = e.target.value

    if (e.target.name === "cep") {
      resultado = e.target.value.replaceAll("_", "").replaceAll(".", "").replaceAll("-", "");
      buscaCep(resultado)
    }

    setAlteraDados({ ...DadosVenda, [e.target.name]: resultado.toUpperCase() })


  };

  async function handleChangeInputContato(e: ChangeEvent<HTMLInputElement>) {
    var resultado = e.target.value;

    resultado = resultado.replaceAll("_", "").replaceAll(".", "");
    setModelContato({
      ...modelContato,
      [e.target.name]: resultado
    });
  }

  async function handleChangeEmail(e: ChangeEvent<HTMLInputElement>) {
    var resultado = e.target.value;
    setCampoEmail({
      tipoContato: "EMAIL", valor: resultado
    });
  }

  function enderecoCobranca(e: ChangeEvent<HTMLInputElement>) {
    if (DadosVenda.enderecoCobranca === "RES") {
      setAlteraDados({ ...DadosVenda, enderecoCobranca: "COM" })
    } else {
      setAlteraDados({ ...DadosVenda, enderecoCobranca: "RES" })
    }
  }

  async function passaFase3() {
    if (DadosVenda.codB === 0) {
      addToast({
        type: 'error',
        title: 'Erro bem selecionado',
        description: 'Ao retornar a primeira pagina, por favor selecione o bem novamente!'
      });
      setAlteraPagina(0)
    }
    const tudo = JSON.stringify(DadosVenda)
    const teste = JSON.parse(tudo)
    let grupoInaugural = DadosVenda.grupo;

    if (DadosVenda?.id > 0) {
      const response = await api.put(`v1/pre-vendas/${DadosVenda.id}`, {
        idVendedor: DadosVenda.idVendedor,
        idTabela: DadosVenda.idTabela,
        documento: DadosVenda.documento,
        dataCriacao: DadosVenda.dataAdesao,
        etapa: 3,
        conteudo: tudo,      
        dataExportacao: DadosVenda.dataAdesao,
        status: "PENDENTE",
        posVenda: "PENDENTE",

      })

      console.log(response.status)

      if (response.status === 200) {
        setAlteraDados({
          ...DadosVenda,
          id: response.data[0].id,
          etapa4: false,

        })
      }

      setAlteraPagina(3)
    } else {
      const response = await api.post(`v1/pre-vendas`, {
        idVendedor: DadosVenda.idVendedor,
        idTabela: DadosVenda.idTabela,
        documento: DadosVenda.documento,
        dataCriacao: DadosVenda.dataAdesao,
        etapa: 3,
        conteudo: tudo,
        dataExportacao: DadosVenda.dataAdesao,
        status: "PENDENTE",
        posVenda: "PENDENTE",

      })

      if (response.status === 201) {
        setAlteraDados({
          ...DadosVenda,
          id: response.data[0].id,
          etapa4: false,

        })

        setAlteraPagina(3)
      }
    }


  }



  return (
    <>
      <Container>
        <Row between>
          <Col sx={12} sm={2}>
              <FormControl className="teste" variant="standard" style={{ marginTop: 5 }} >
                <InputMask
                  mask="99.999-999"
                  onChange={handleChangeInput}
                  value={DadosVenda.cep}
                >
                  {() =>
                    <TextField
                      className='teste'
                      required
                      id="standard-required"
                      label="CEP"
                      variant="standard"
                      name='cep'
                    />
                  }
                </InputMask>
              </FormControl>
          </Col>
          <Col xs={12} sm={5}>
            <div className="inputNovo">
              <FormControl className="inputNovo" variant="standard" style={{ marginTop: 7 }} >
                <TextField
                  InputLabelProps={{ shrink: DadosVenda.endereco.length !== "" ? true : false }}
                  required
                  className='inputNovo'
                  inputProps={{ maxlength: 64 }}
                  id="standard-required"
                  label="Endereço (Rua, Av, Praça)"
                  variant="standard"
                  name='endereco'
                  value={DadosVenda.endereco}
                  onChange={handleChangeInput}
                />
              </FormControl>
            </div>
          </Col>
          <Col xs={3} sm={1}>
            <div className="inputNovo">
              <FormControl className="inputNovo" variant="standard" style={{ marginTop: 7 }} >
                <TextField
                  required
                  className='inputNovo'
                  id="standard-required"
                  inputProps={{ maxlength: 6 }}
                  label="Número"
                  variant="standard"
                  name='numero'
                  value={DadosVenda.numero}
                  onChange={handleChangeInput}
                />
              </FormControl>
            </div>
          </Col>
          <Col xs={9} sm={4}>
            <div className="inputNovo">
              <FormControl className="inputNovo" variant="standard" style={{ marginTop: 7 }} >
                <TextField
                  InputLabelProps={{ shrink: DadosVenda.bairro.length > 0 ? true : false }}
                  required
                  className='inputNovo'
                  inputProps={{ maxlength: 36 }}
                  id="standard-required"
                  label="Bairro"
                  variant="standard"
                  name='bairro'
                  value={DadosVenda.bairro}
                  onChange={handleChangeInput}
                />
              </FormControl>
            </div>
          </Col>
        </Row>

        <Row>
          <Col xs={3} sm={1}>
            <div className="inputNovo">
              <FormControl className="inputNovo" variant="standard" style={{ marginTop: 7 }} >
                <TextField
                  className='inputNovo'
                  id="standard-required"
                  label="Apto"
                  inputProps={{ maxlength: 6 }}
                  variant="standard"
                  name='apto'
                  value={DadosVenda.apto}
                  onChange={handleChangeInput}
                />
              </FormControl>
            </div>
          </Col>
          <Col xs={9} sm={3}>
              <FormControl className="inputNovo" variant="standard" style={{ marginTop: 7 }} >
                <TextField
                  className='inputNovo'
                  id="standard-required"
                  label="Complemento"
                  inputProps={{ maxlength: 11 }}
                  variant="standard"
                  name='complemento'
                  value={DadosVenda.complemento}
                  onChange={handleChangeInput}
                />
              </FormControl>
          </Col>
          <Col xs={3} sm={1}>
            <div className="inputNovo">
              <FormControl className="inputNovo" variant="standard" style={{ marginTop: 7 }} >
                <TextField
                  InputLabelProps={{ shrink: DadosVenda.uf.length > 0 ? true : false }}
                  required
                  className='inputNovo'
                  inputProps={{ maxlength: 2 }}
                  id="standard-required"
                  label="Estado"
                  variant="standard"
                  name='uf'
                  value={DadosVenda.uf}
                  onChange={handleChangeInput}
                />
              </FormControl>
            </div>
          </Col>
          <Col xs={9} sm={5}>
            <div className="inputNovo">
              <FormControl className="inputNovo" variant="standard" style={{ marginTop: 7 }} >
                <TextField
                  InputLabelProps={{ shrink: DadosVenda.cidade.length > 0 ? true : false }}
                  required
                  className='inputNovo'
                  id="standard-required"
                  inputProps={{ maxlength: 40 }}
                  label="Cidade"
                  variant="standard"
                  name='cidade'
                  value={DadosVenda.cidade}
                  onChange={handleChangeInput}
                />
              </FormControl>
            </div>
          </Col>
          <Col xs={12} sm={2} className="d-flex justify-content-end">

            <FormControlLabel style={{ marginTop: "26px" }} control={<Checkbox checked={DadosVenda.enderecoCobranca === "RES" ? true : false} onChange={enderecoCobranca} sx={{ color: 'var(--blue)', '&.Mui-checked': { color: 'var(--blue)' } }} />} label="End. Cob." />
          </Col>
        </Row>

        <Row between>
        <Row start nowrap  style={{ maxWidth: 520, minWidth: 180 }}>
          <Col min='180px'>
            <FormControl className="inputNovo" variant="standard">
              <InputMask
                mask="(99) 999999999"
                onChange={handleChangeInputContato}
                value={modelContato.valor}
              >
                {() =>
                  <TextField
                    className='inputNovo'
                    id="standard-required"
                    label="Telefone"
                    variant="standard"
                    name="valor"
                  />
                }
              </InputMask>
            </FormControl>
          </Col>
          <Col min='40px' max='60px'>
            <div style={{ backgroundColor: "var(--blue)", height: "30px", width: "30px", marginTop: "18px", cursor: "pointer" }} onClick={inserirContatoTelefone}>
              <FiPlus color="#fff" style={{ backgroundColor: "var(--blue)", marginTop: "5px", marginLeft: "5px" }} size={20} />
            </div>
          </Col>
        </Row>

        <Row start nowrap style={{ maxWidth: 520, minWidth: 180 }}>
          <Col min='180px'>
            <FormControl className="inputNovo" variant="standard">
              <TextField
                className='inputNovo'
                id="standard-required"
                label="E-mail"
                variant="standard"
                name="EMAIL"
                type="email"
                value={campoEmail.valor}
                onChange={handleChangeEmail}
              />
            </FormControl>
          </Col>
          <Col min='40px' max='60px'>
            <div style={{ backgroundColor: "var(--blue)", height: "30px", width: "30px", marginTop: "18px", cursor: "pointer" }} onClick={inserirContatoEmail}>
              <FiPlus color="#fff" style={{ backgroundColor: "var(--blue)", marginTop: "5px", marginLeft: "5px" }} size={20} />
            </div>
          </Col>
        </Row>
        </Row>
        
        <Row between>
        <Row start nowrap style={{ maxWidth: 520, minWidth: 180 }}>
          <Col>
            {DadosVenda.telefone1 !== "" ?
              <Card style={{ marginTop: "10px" }}>
                <LightTooltip title={DadosVenda.telefone1}>
                  <CardHeader
                    avatar={
                      <Avatar sx={{ bgcolor: cores.telefone1 }} aria-label="recipe">
                        <BiPhone></BiPhone>
                      </Avatar>
                    }
                    action={
                      <IconButton aria-label="settings" onClick={() => excluirFone("telefone1")}>
                        <FiXCircle />
                      </IconButton>
                    }
                    title={DadosVenda.telefone1}
                  />
                </LightTooltip>
              </Card> : <></>
            }

            {DadosVenda.telefone2 !== "" ?
              <Card style={{ marginTop: "10px" }}>
                <LightTooltip title={DadosVenda.telefone2}>
                  <CardHeader

                    avatar={
                      <Avatar sx={{ bgcolor: cores.telefone2 }} aria-label="recipe">
                        <BiPhone></BiPhone>

                      </Avatar>
                    }
                    action={
                      <IconButton aria-label="settings" onClick={() => excluirFone("telefone2")}>
                        <FiXCircle />
                      </IconButton>
                    }
                    title={DadosVenda.telefone2}
                  />
                </LightTooltip>
              </Card> : <></>
            }

            {DadosVenda.telefone3 !== "" ?
              <Card style={{ marginTop: "10px" }}>
                <LightTooltip title={DadosVenda.telefone3}>
                  <CardHeader

                    avatar={
                      <Avatar sx={{ bgcolor: cores.telefone3 }} aria-label="recipe">
                        <BiPhone></BiPhone>

                      </Avatar>
                    }
                    action={
                      <IconButton aria-label="settings" onClick={() => excluirFone("telefone3")}>
                        <FiXCircle />
                      </IconButton>
                    }
                    title={DadosVenda.telefone3}
                  />
                </LightTooltip>
              </Card> : <></>
            }

            {DadosVenda.telefone4 !== "" ?
              <Card style={{ marginTop: "10px" }}>
                <LightTooltip title={DadosVenda.telefone4}>
                  <CardHeader

                    avatar={
                      <Avatar sx={{ bgcolor: cores.telefone4 }} aria-label="recipe">
                        <BiPhone></BiPhone>

                      </Avatar>
                    }
                    action={
                      <IconButton aria-label="settings" onClick={() => excluirFone("telefone4")}>
                        <FiXCircle />
                      </IconButton>
                    }
                    title={DadosVenda.telefone4}
                  />
                </LightTooltip>
              </Card> : <></>
            }
          </Col>
        </Row>

        <Row start nowrap style={{ maxWidth: 520, minWidth: 180 }} >
          <Col>
            {DadosVenda.email1 !== "" ?
              <Card style={{ marginTop: "10px" }}>
                <LightTooltip title={DadosVenda.email1}>
                  <CardHeader

                    avatar={
                      <Avatar sx={{ bgcolor: cores.email1 }} aria-label="recipe">
                        <AiOutlineMail></AiOutlineMail>

                      </Avatar>
                    }
                    action={
                      <IconButton aria-label="settings" onClick={() => excluirEmail("email1")}>
                        <FiXCircle />
                      </IconButton>
                    }
                    title={DadosVenda.email1.length > 30?DadosVenda.email1.slice(0,28)+'...':DadosVenda.email1}
                  />
                </LightTooltip>
              </Card> : <></>
            }

            {DadosVenda.email2 !== "" ?
              <Card style={{ marginTop: "10px" }}>
                <LightTooltip title={DadosVenda.email2}>
                  <CardHeader

                    avatar={
                      <Avatar sx={{ bgcolor: cores.email2 }} aria-label="recipe">
                        <AiOutlineMail></AiOutlineMail>

                      </Avatar>
                    }
                    action={
                      <IconButton aria-label="settings" onClick={() => excluirEmail("email2")}>
                        <FiXCircle />
                      </IconButton>
                    }
                    title={DadosVenda.email2.length > 30?DadosVenda.email2.slice(0,28)+'...':DadosVenda.email2}
                  />
                </LightTooltip>
              </Card> : <></>
            }

            {DadosVenda.email3 !== "" ?
              <Card style={{ marginTop: "10px" }}>
                <LightTooltip title={DadosVenda.email3}>
                  <CardHeader

                    avatar={
                      <Avatar sx={{ bgcolor: cores.email3 }} aria-label="recipe">
                        <AiOutlineMail></AiOutlineMail>
                      </Avatar>
                    }
                    action={
                      <IconButton aria-label="settings" onClick={() => excluirEmail("email3")}>
                        <FiXCircle />
                      </IconButton>
                    }
                    title={DadosVenda.email3}
                  />
                </LightTooltip>
              </Card> : <></>
            }

            {DadosVenda.email4 !== "" ?
              <Card style={{ marginTop: "10px" }}>
                <LightTooltip title={DadosVenda.email4}>
                  <CardHeader

                    avatar={
                      <Avatar sx={{ bgcolor: cores.email4 }} aria-label="recipe">
                        <AiOutlineMail></AiOutlineMail>

                      </Avatar>
                    }
                    action={
                      <IconButton aria-label="settings" onClick={() => excluirEmail("email4")}>
                        <FiXCircle />
                      </IconButton>
                    }
                    title={DadosVenda.email4}
                  />
                </LightTooltip>
              </Card> : <></>
            }
          </Col>
        </Row>
        </Row>

        <Row style={{ marginTop: 35 }}>
          <Col>
            <Form.Group className="mb-3 teste right" as={Col} controlId="formGridEmail">
              <div className="botaoPesquisar">
                <Button variant="primary" type="submit" className="btnPesquisar" onClick={passaFase3}
                  disabled={DadosVenda.cep === "" ||
                    DadosVenda.endereco === "" ||
                    DadosVenda.numero === "" ||
                    DadosVenda.bairro === "" ||
                    DadosVenda.uf === "" ||
                    DadosVenda.cidade === "" ||
                    (DadosVenda.telefone1 === "" && DadosVenda.telefone2 === "" && DadosVenda.telefone3 === "" && DadosVenda.telefone4 === "") ||
                    (DadosVenda.email1 === "" && DadosVenda.email2 === "" && DadosVenda.email3 === "" && DadosVenda.email4 === "")

                    ? true : false
                  }>
                  <Typography variant="button" gutterBottom> PRÓXIMO</Typography>
                </Button>
              </div>
            </Form.Group>
          </Col>
        </Row>
      </Container>
    </>
  )
}